const EMPLOYEE = [
  { id: "employee", title: "Employee" },
];

const CHANGE_TYPES = ["Kenyan Citizen", "Foreigner", "Foreign Resident"];

export { EMPLOYEE, CHANGE_TYPES };
